import resume from "../assets/pdf/resume.pdf";
import profile from "../../src/assets/png/profile.png"

export const headerData = {
  name: "Ali Hamza",
  title: "Full Stack Web Developer",
  desciption:
    "I'm Ambitious to my work with the appreciated skills and confidence even under pressure circumstances.I'd like to learn and work with new technologies.",
  image: profile,
  resumePdf: resume,
};
